export const mockV1RelationshipPut = {
  relationshipId: 'acd10578-7454-11ea-bc55-0242ac130003'
};

export default mockV1RelationshipPut;
